<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
		<g id="Ellipse_758" data-name="Ellipse 758" fill="none" stroke="#e83454" stroke-width="1">
			<circle cx="13" cy="13" r="13" stroke="none" />
			<circle cx="13" cy="13" r="12.5" fill="none" />
		</g>
		<rect id="Rectangle_14080" data-name="Rectangle 14080" width="10" height="10" rx="2" transform="translate(8 8)" fill="#e6345a" />
	</svg>
</template>

<script>
export default {
	name: 'StopRecordingSvg',
};
</script>
